import { CapacitorConfig } from '@capacitor/cli';

const config: CapacitorConfig = {
  appId: 'com.alulatechnologies.vitalscore',
  appName: 'VivaScore',
  webDir: 'www/browser',
  loggingBehavior: 'production',

  server: {
    errorPath: '/'
  },
  plugins: {
    SplashScreen: {
      launchAutoHide: true,
      launchShowDuration: 10000,
      androidSplashResourceName: "splash",
      androidScaleType: "CENTER_CROP",
      backgroundColor: "#ffffff",
      splashFullScreen: true,
      splashImmersive: true,
      useDialog: false
    },
    Keyboard: {
      resizeOnFullScreen: true   // 👈 important for Android
    }
  },

  ios: {
    scheme: 'production',
    handleApplicationNotifications: false
  },

  android: {
    flavor: 'production',
    loggingBehavior: 'none'
  }
};

export default config;
